import React from "react";
import ReportsExpand from "../common/ReportsExpand";

function OhioTrainingDetails({ isFavorite, toggleFavorite, ...rest }) {
  const openReport = () => {
    const url = `https://safyreports.azurewebsites.net/Reports/OhioTraining/TrainingDetails?db=OhioTraining`;
    window.open(url, "Ohio Training Details Report");
  };

  return (
    <ReportsExpand
      title="Ohio Training Details"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      {...rest}
    >
      <div className="row" style={{ minHeight: "60px" }}>
        <div className="col-11 px-4">
          <i
            className="fas fa-arrow-circle-right fa-3x float-end"
            onClick={openReport}
          ></i>
        </div>
      </div>
    </ReportsExpand>
  );
}

export default OhioTrainingDetails;
